module.exports = __webpack_public_path__ + "static/media/react-native.5bc2d712.svg";